import _ from 'lodash';

export const getEmployeeNames = (employeelist, idList) => {
  const names = [];
  idList.forEach((element) => {
    const obj = employeelist.find((e) => e.userId == element);
    if (obj) {
      names.push(obj.name);
    }
  });
  return names;
};

export const getGroupNames = (grouplist, idList) => {
  const names = [];
  idList.forEach((element) => {
    const obj = grouplist.find((e) => e.userGroupId == element);
    if (obj) {
      names.push(obj.userGroupName);
    }
  });
  return names;
};

export const scopeMapToList = (obj) => {
  if (!obj || _.isEmpty(obj)) {
    return {};
  }
  return Object.keys(obj).map((key) => ({
    key,
    value: obj[key],
  }));
};

export const scopeListToMap = (list) => {
  const res = {};

  if (!list || !_.isArray(list)) {
    return res;
  }

  list.forEach((ele) => {
    if (_.isArray(ele.value)) {
      res[ele.key] = ele.value;
    } else {
      res[ele.key] = ele.value.split(',');
    }
  });

  return res;
};

export const getKeys = (list, name) => {
  if (name == undefined) {
    name = 'key';
  }
  const res = {};
  if (!list || !_.isArray(list)) {
    return res;
  }
  list.forEach((e) => {
    res[e[name]] = true;
  });

  return res;
};
